import { render, staticRenderFns } from "./updHklrTerms.vue?vue&type=template&id=ac8084fe"
import script from "./updHklrTerms.vue?vue&type=script&lang=js"
export * from "./updHklrTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports